import React, { useState, useEffect, useRef } from 'react';
import {
  useFirebaseContext,
  useShowTaskEditBoxContext,
  useTargetListEditContext,
  useDateTimeContext,
  useAllInOneContext,
  useActiveListContext,
} from '../../../context';
import { ListChoices } from './list-choices';
import {
  getDate,
  getTime,
  checkListExist,
  getTaskCount,
  resizeOnInput,
} from '../../../helpers';
import { Float } from '../../float';
import { timestamp } from '../../../lib';
import { TimePicker } from '../../time_picker';
import { Core } from '../..';
import '../../core/styles/styles.css';
import { COLORS } from '../../../constants';
import { CSSTransition } from 'react-transition-group';
import { NewDatePicker } from '../../modified_date_picker';
import { ListChoiceRedirect } from './styles';
import {
  FaClock,
  FaRegCalendarAlt,
  FaStar,
  FaChevronRight,
} from 'react-icons/fa';

export const EditTask = () => {
  const textareaRef = useRef();
  const textareaNoteRef = useRef();
  const { firebase } = useFirebaseContext();
  const {
    lists,
    setLists,
    allTasks,
    setAllTasks,
    setMaxModifiedAt,
  } = useAllInOneContext();

  const [showLists, setShowLists] = useState(false);
  const [progress, setProgress] = useState(0);
  const {
    showTaskEditBox,
    setShowTaskEditBox,
    targetEditTask,
    setTargetEditTask,
  } = useShowTaskEditBoxContext();
  const [invalid, setInvalid] = useState(false);

  const [task, setTask] = useState();
  const [note, setNote] = useState();
  const [important, setImportant] = useState();
  const { targetList, setTargetList, listName } = useTargetListEditContext();
  const {
    activeList,
    setActiveList,
    themeColor,
    themeColor_L2,
  } = useActiveListContext();
  const [forceCloseNotYet, setForceCloseNotYet] = useState(true);
  const [isInEdit, setIsInEdit] = useState(false);

  const {
    dueDate,
    setDueDate,
    hour,
    setHour,
    minute,
    setMinute,
    period,
    setPeriod,
    showDate,
    setShowDate,
    showTime,
    setShowTime,
    resetDate,
    resetTime,
    toggleDate,
    toggleTime,
    changeHour,
    changeMinute,
  } = useDateTimeContext();

  const [colorIndex, setColorIndex] = useState();

  useEffect(() => {
    if (targetList && lists) {
      const index = lists.findIndex((ele) => ele.docID == targetList);

      if (index > -1) setColorIndex(index);
    }
  }, [targetList, lists]);

  useEffect(() => {
    if (targetEditTask) {
      setTask(targetEditTask.title);
      setNote(targetEditTask.note);
      setImportant(targetEditTask.important);
      setTargetList(targetEditTask.listID);

      if (targetEditTask.date != '') {
        setDueDate(new Date(targetEditTask.date));
        setShowDate(true);
      }

      if (targetEditTask.time != '') {
        const temp1 = targetEditTask.time.split(' ');
        const temp2 = temp1[0].split(':');
        setHour(temp2[0]);
        setMinute(temp2[1]);
        setPeriod(temp1[1]);
        setShowTime(true);
      }
    }
  }, [targetEditTask]);

  const resetStates = () => {
    setTask('');
    setNote('');
    setImportant(false);
    resetDate();
    resetTime();
  };

  const resetAll = () => {
    resetStates();
    setTargetList('');
  };

  const closeAll = () => {
    setShowLists(false);

    setShowTaskEditBox(false);
    setTargetEditTask();
    setShowDate(false);
    setShowTime(false);
    setForceCloseNotYet(true);
  };

  useEffect(() => {
    if (!forceCloseNotYet) {
      closeAll();
      resetAll();
    }
  }, [forceCloseNotYet]);

  useEffect(() => {
    resetStates();
  }, []);

  useEffect(() => {
    if (task != '') setInvalid(false);
    else setInvalid(true);
  }, [task]);

  useEffect(() => {
    if (lists) {
      if (targetList == '' || !checkListExist(targetList, lists))
        setShowTaskEditBox(false);
    }
  }, [lists]);

  const editTask = () => {
    if (targetEditTask) {
      const targetListID = targetEditTask.listID;
      const changeList = targetList != targetListID;
      let finalOrder = targetEditTask.order;

      const userDB = firebase
        .firestore()
        .collection('users')
        .doc(firebase.auth().currentUser.uid);
      const taskDB = userDB.collection('tasks');
      const listDB = userDB.collection('lists');
      const tempModifiedAt = timestamp.now().toMillis();

      const tempLists = lists,
        tempTasks = allTasks;
      setProgress(20);

      if (changeList) {
        let temp = getTaskCount(targetListID, lists) - 1,
          index;
        listDB
          .doc(targetListID)
          .update({ taskCount: temp, modifiedAt: tempModifiedAt });
        index = tempLists.findIndex((item) => item.docID == targetListID);
        tempLists[index].taskCount = temp;
        tempLists[index].modifiedAt = tempModifiedAt;

        tempTasks
          .filter(
            (item) => item.listID == targetListID && item.order > finalOrder
          )
          .map((doc) => {
            taskDB.doc(doc.docID).update({
              order: doc.order - 1,
              modifiedAt: tempModifiedAt,
            });

            doc.order = doc.order - 1;
            doc.modifiedAt = tempModifiedAt;
          });

        finalOrder = getTaskCount(targetList, lists);

        listDB
          .doc(targetList)
          .update({ taskCount: finalOrder + 1, modifiedAt: tempModifiedAt });

        index = tempLists.findIndex((item) => item.docID == targetList);
        tempLists[index].taskCount = finalOrder + 1;
        tempLists[index].modifiedAt = tempModifiedAt;
      }

      const tmpDate = getDate(showDate, dueDate),
        tmpTime = getTime(showTime, hour, minute, period);
      setProgress(40);

      taskDB
        .doc(targetEditTask.docID)
        .update({
          order: finalOrder,
          important: important,
          listID: targetList,
          title: task,
          note: note,
          date: tmpDate,
          time: tmpTime,
          modifiedAt: tempModifiedAt,
        })
        .then(() => {
          setProgress(60);
          const index = tempTasks.findIndex(
            (item) => item.docID == targetEditTask.docID
          );
          tempTasks[index].order = finalOrder;
          tempTasks[index].important = important;
          tempTasks[index].listID = targetList;
          tempTasks[index].title = task;
          tempTasks[index].note = note;
          tempTasks[index].date = tmpDate;
          tempTasks[index].time = tmpTime;
          tempTasks[index].modifiedAt = tempModifiedAt;

          setAllTasks(tempTasks);

          if (changeList) setLists(tempLists);
          setProgress(80);

          setActiveList();
          setActiveList(activeList);
          setProgress(100);

          setIsInEdit(false);
          setMaxModifiedAt(tempModifiedAt);

          resetAll();
          closeAll();
        });
    }
  };

  useEffect(() => {
    if (targetEditTask && showTaskEditBox) {
      if (textareaRef && textareaRef.current) {
        textareaRef.current.value = targetEditTask.title;

        resizeOnInput(textareaRef.current);
      }
      if (textareaNoteRef && textareaNoteRef.current) {
        textareaNoteRef.current.value = targetEditTask.note;

        resizeOnInput(textareaNoteRef.current);
      }
    }
  }, [targetEditTask, showTaskEditBox]);

  return (
    <>
      <Core.ForceAlert
        progress={progress}
        setProgress={setProgress}
        color={themeColor}
        showBox={isInEdit}
      >
        Saving the Changes...
      </Core.ForceAlert>
      <div>
        <Float.Card
          disabled={invalid}
          showBox={targetEditTask && showTaskEditBox}
          color={themeColor}
          color_L2={themeColor_L2}
          setShowBox={setForceCloseNotYet}
          type='Task'
        >
          <Float.CardChild type='Task'>
            <Core.Slider type='Task' showBox={showLists}>
              <CSSTransition
                in={!showLists}
                timeout={300}
                classNames='display'
                unmountOnExit
              >
                <div className='target-child'>
                  <div className='title'>Task Details</div>

                  <div className='block'>
                    <div
                      style={{
                        display: 'flex',
                        borderBottom: '1px solid rgba(0,0,0,0.1)',
                        padding: '4px',
                      }}
                    >
                      <Core.TextArea
                        forwardedRef={textareaRef}
                        type='text'
                        value={task}
                        placeholder='Task Name'
                        onChange={(e) => {
                          resizeOnInput(e.target);
                          setTask(e.target.value);
                        }}
                        rows='1'
                        style={{ width: '100%' }}
                      ></Core.TextArea>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        borderTop: '1px solid rgba(0,0,0,0.1)',
                        padding: '4px',
                      }}
                    >
                      <Core.TextArea
                        forwardedRef={textareaNoteRef}
                        value={note}
                        type='text'
                        placeholder='Note'
                        onChange={(e) => {
                          resizeOnInput(e.target);
                          setNote(e.target.value);
                        }}
                        style={{ width: '100%' }}
                      ></Core.TextArea>
                    </div>
                  </div>
                  <div className='block'>
                    <div style={{ padding: '10px 15px' }}>
                      <Float.OptionHeader
                        color={themeColor}
                        value={showDate}
                        fun={() => toggleDate()}
                      >
                        <div
                          style={{
                            display: 'flex',

                            alignItems: 'center',
                          }}
                        >
                          <span
                            style={{
                              background: '#ea4e3d',
                              color: 'white',
                              padding: '5px',
                              borderRadius: '5px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginRight: '10px',
                              boxShadow: '2px 2px 4px rgb(0 0 0 / 15%)',
                            }}
                          >
                            <FaRegCalendarAlt />
                          </span>
                          <span>Date</span>
                        </div>
                      </Float.OptionHeader>
                      {showDate && (
                        <div
                          style={{
                            justifyContent: 'center',
                            display: 'flex',
                            paddingTop: '10px',
                          }}
                        >
                          <NewDatePicker
                            themeColor={themeColor}
                            dueDate={dueDate}
                            setDueDate={setDueDate}
                          />
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        padding: '10px 15px',
                        borderTop: '2px solid rgba(0,0,0,0.1)',
                      }}
                    >
                      <Float.OptionHeader
                        color={themeColor}
                        value={showTime}
                        fun={() => toggleTime()}
                      >
                        <div
                          style={{
                            display: 'flex',

                            alignItems: 'center',
                          }}
                        >
                          <span
                            style={{
                              background: '#3478f6',
                              color: 'white',
                              padding: '5px',
                              borderRadius: '5px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginRight: '10px',
                              boxShadow: '2px 2px 4px rgb(0 0 0 / 15%)',
                            }}
                          >
                            <FaClock />
                          </span>
                          <span>Time</span>
                        </div>
                      </Float.OptionHeader>

                      {showTime && (
                        <div
                          style={{
                            justifyContent: 'center',
                            display: 'flex',
                            paddingTop: '10px',
                          }}
                        >
                          <TimePicker
                            hour={hour}
                            changeHour={changeHour}
                            minute={minute}
                            changeMinute={changeMinute}
                            period={period}
                            setPeriod={setPeriod}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='block' style={{ padding: '10px 15px' }}>
                    <Float.OptionHeader
                      color={themeColor}
                      value={important}
                      fun={() => setImportant(!important)}
                    >
                      <div
                        style={{
                          display: 'flex',

                          alignItems: 'center',
                        }}
                      >
                        <span
                          style={{
                            background: '#f09a37',
                            color: 'white',
                            padding: '5px',
                            borderRadius: '5px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginRight: '10px',
                            boxShadow: '2px 2px 4px rgb(0 0 0 / 15%)',
                          }}
                        >
                          <FaStar />
                        </span>
                        <span>Important</span>
                      </div>
                    </Float.OptionHeader>
                  </div>
                  <div className='block'>
                    {targetList && lists && lists[colorIndex] && (
                      <ListChoiceRedirect
                        color={COLORS[lists[colorIndex].color]}
                        color_L2={themeColor_L2}
                        onClick={() => {
                          setShowLists(true);
                        }}
                      >
                        <div>List</div>
                        <div>
                          <div>
                            <span className='list-dot'></span>
                            <span>{listName}</span>
                          </div>
                          <span
                            style={{
                              marginLeft: '10px',
                              color: 'rgba(0,0,0,0.35)',
                            }}
                          >
                            <FaChevronRight />
                          </span>
                        </div>
                      </ListChoiceRedirect>
                    )}
                  </div>
                </div>
              </CSSTransition>

              <CSSTransition
                in={showLists}
                timeout={300}
                classNames='display'
                unmountOnExit
              >
                <ListChoices setShowLists={setShowLists} option={'Edit'} />
              </CSSTransition>
            </Core.Slider>
          </Float.CardChild>
          <div>
            <div
              onClick={() => {
                setIsInEdit(true);
                editTask();
              }}
            >
              Done
            </div>

            <div
              onClick={() => {
                resetAll();

                closeAll();
              }}
            >
              Cancel
            </div>
          </div>
        </Float.Card>
      </div>
    </>
  );
};
